import PropTypes from "prop-types";
import classNames from "classnames";

import "./ReadOnlyText.css";

export function ReadOnlyText({ id, ariaLabel, value, multiline }) {
  return (
    // biome-ignore lint/a11y/useSemanticElements: intentionally using div instead of textarea/input so text can expand to full height
    <div
      role="textbox"
      aria-readonly="true"
      aria-label={ariaLabel}
      tabIndex={0}
      id={id}
      className={classNames({
        "read-only-text": true,
        "read-only-text--multiline": multiline,
      })}
    >
      {value}
    </div>
  );
}

ReadOnlyText.propTypes = {
  id: PropTypes.string,
  ariaLabel: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  multiline: PropTypes.bool,
};
